import { openIndexedDb, transactionDone } from '../utils/idb';
import type { HistorySecretRecord } from './types';

const DB_NAME = 'family-messenger-history-secrets';
const DB_VERSION = 1;
const STORE_NAME = 'history_secret_records';

function openDb(): Promise<IDBDatabase> {
  return openIndexedDb(DB_NAME, DB_VERSION, (db) => {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      const store = db.createObjectStore(STORE_NAME, { keyPath: 'secretId' });
      store.createIndex('byIdentity', 'scope.identityId');
      store.createIndex('byIdentityCreatedAt', ['scope.identityId', 'createdAt']);
      store.createIndex('byProfile', 'profile');
      store.createIndex('byStatus', 'status');
    }
  });
}

export async function saveHistorySecretRecords(records: HistorySecretRecord[]): Promise<void> {
  const db = await openDb();
  try {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    for (const record of records) store.put(record);
    await transactionDone(tx);
  } finally {
    db.close();
  }
}

export async function deleteHistorySecretRecordsForIdentity(identityId: string): Promise<void> {
  const target = (identityId || '').trim();
  if (!target) return;
  const db = await openDb();
  try {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const index = tx.objectStore(STORE_NAME).index('byIdentity');
    const keys = await new Promise<IDBValidKey[]>((resolve, reject) => {
      const request = index.getAllKeys(target);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
    for (const key of keys) tx.objectStore(STORE_NAME).delete(key);
    await transactionDone(tx);
  } finally {
    db.close();
  }
}
